import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

import {NgHeaderTciComponent} from "./ng-header-tci.component";
// import { TciTenantService } from "src/app/ng-tenant/tci-tenant.service";
// import {TciTenantModelService} from "src/app/ng-tenant/tci-tenant.model";
import {NgSharedModule} from "../ng-shared/ng-shared.module";
import {TciTenantModule} from "../ng-tenant/tci-tenant.module";
import {CookieService} from "angular2-cookie/services/cookies.service";

import {TCITenantRemoteServices} from "../ng-tenant/tci-tenant-remote-services";
import {TciTenantService} from "../ng-tenant/tci-tenant.service";
import {TciTenantModelService} from "../ng-tenant/tci-tenant.model";
import {NgUserService} from "../ng-shared/ng-services/ng-user.service";
import {NgMarketplaceV2Service} from "../ng-marketplace-v2/ng-marketplace-v2.service";
import {Http} from "@angular/http";

export function NgMarketplaceV2ServiceFactory(
    tenantRemoteServices: TCITenantRemoteServices,
    tenantSvc: TciTenantService,
    tenantModelSvc: TciTenantModelService,
    userSvc: NgUserService,
    http: Http
): NgMarketplaceV2Service {
    return NgMarketplaceV2Service.getInstance(tenantRemoteServices, tenantSvc, tenantModelSvc, userSvc, http);
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgSharedModule,
        TciTenantModule
    ],
    declarations: [
        NgHeaderTciComponent
    ],
    providers: [
        // TciTenantModelService,
        TranslateService,
        CookieService,
        {
            provide: NgMarketplaceV2Service,
            useFactory: NgMarketplaceV2ServiceFactory,
            deps: [
                TCITenantRemoteServices,
                TciTenantService,
                TciTenantModelService,
                NgUserService,
                Http
            ]
        }
    ],
    exports: [
        NgHeaderTciComponent
    ]
})
export class NgHeaderTCIModule {
}
